module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 pr-0"
  }, [_c('nav', [_c('ul', {
    staticClass: "pagination pagination-sm"
  }, [(_vm.showPrevious()) ? _c('li', {
    staticClass: "page-item",
    class: {
      'disabled': _vm.currentPage <= 1
    }
  }, [(_vm.currentPage <= 1) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.previousText))])]) : _vm._e(), (_vm.currentPage > 1) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.currentPage - 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.previousText))])]) : _vm._e()]) : _vm._e(), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        'active': page === _vm.currentPage
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), (_vm.showNext()) ? _c('li', {
    staticClass: "page-item",
    class: {
      'disabled': _vm.currentPage === _vm.lastPage || _vm.lastPage === 0
    }
  }, [(_vm.currentPage === _vm.lastPage || _vm.lastPage === 0) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.nextText))])]) : _vm._e(), (_vm.currentPage < _vm.lastPage) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.currentPage + 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.nextText))])]) : _vm._e()]) : _vm._e()], 2)])]), _c('div', {
    staticClass: "col-7 pl-0"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Exibindo " + _vm._s(_vm.initialInterval) + "-" + _vm._s(_vm.finalInterval) + " de " + _vm._s(_vm.total))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61f8971e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Paginacao.vue
// module id = 481
// module chunks = 1